<template>
    <div>
        <h1>Campaign detail</h1>
        <!-- <default-layout :lbl="lbl"
                        :locale="locale"
                        :isLogin="isLogin"
                        :profile="profile"
                        :campaign="campaign"
                        v-if="isLoaded"
        ></default-layout> -->
    </div>
</template>
<script>
import Locale from '@/helper/locale/locale.js';
// import DefaultLayout from "@/module/Detail/component/layout/Default.vue";
//core
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
import { CampaignConfigBuilder } from "@/core/Campaign/model/CampaignConfigModel.js";

export default {
    name: "PageDetail",
    components: {
        // DefaultLayout
    },
    data: function() {
        return {
            isLogin: false,
            user: {},
            profile: {},
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),

            isLoaded: false,
            campaignId: '',
            campaign: null,
            campaignConfig: null,
        };
    },
    created: function() {
        this.initialConfig();
        this.getCampaign();
        console.log('created');
    },
    mounted: function() {
        console.log('mounted');
    },
    activated: function() {
        console.log('activated');
    },
    methods: {
        initialConfig: function () {
            this.campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(this.campaignId)
                .create();
        },
        getCampaign: function() {
            var strBzbsToken = null;
            BzbsCampaign.apiGetCampaignDetail(strBzbsToken, this.campaignConfig).subscribe((result) => {
                this.campaign = result;
                this.isLoaded = true;
            }, (err) => {
                console.log(err);
            });
        },
    },
}
</script>
